exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.largeRight[data-v-18bbadac] {\n    margin-left: 4px;\n    font-size: 28px !important;\n}\n", ""]);
